import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import PortalVue from 'portal-vue';
import { plugin as VueInputAutowidth } from 'vue-input-autowidth';
import i18n from '@speechki-frontend/core/i18n/i18n';

import tooltip from '@speechki-frontend/shared/helpers/plugins/tooltip';
import dnd from '@speechki-frontend/shared/helpers/plugins/dnd';

// global components @todo find a one place to share globals
import Spinner from '@speechki-frontend/shared/ui/Spinner';

// Sentry
import initSentry from '@speechki-frontend/shared/helpers/plugins/sentry';

const app = createApp(App);

app.component('Spinner', Spinner);

app.use(i18n);
app.use(router);
app.use(store);
app.use(PortalVue);
app.use(VueInputAutowidth);
app.use(tooltip);
app.use(dnd);

app.config.globalProperties.$isManageApp = false;
app.config.globalProperties.$isClientApp = false;
app.config.globalProperties.$isCrmApp = true;

initSentry(app);

app.mount('#app');
